import DescriptionOnlyFormValues from "../ReusableFormValues/DescriptionOnlyFormValues";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { evidenceOnPublicExchangeDocumentTypesArray } from "./constants";

interface Props {
  readonly: boolean;
}

const EvidenceOnPublicExchangeFormValues = ({ readonly }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={evidenceOnPublicExchangeDocumentTypesArray}
        placeholder="Select an evidence of listing on public exchange document type"
        name="secondaryDocumentType"
        label="Document sub-type"
      />
      <DescriptionOnlyFormValues readonly={readonly} />
    </>
  );
};

export default EvidenceOnPublicExchangeFormValues;
